

import {
  ADD_REPORT_ERROR, ADD_REPORT_REQUEST, ADD_REPORT_SUCCESS, INPUT_CHANGE, INPUT_ERROR,
  RESET_FORM
} from "./add-report-action-types";

const initialState = {
  reportUrl: {
    value: "",
    error: "",
    field: 'reportUrl'
  },
  name: {
    value: "",
    error: "",
    field: 'name'
  },
  password: {
    value: "",
    error: "",
    field: 'password'
  },
  loading: false,
};

export default ( state = initialState, action ) => {
  const { inputName, inputValue, error, field } = action;

  switch(action.type) {

    case ADD_REPORT_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case ADD_REPORT_REQUEST:
      return {
        ...state,
        loading: true
      };

    case ADD_REPORT_ERROR:
      return {
        ...state,
        loading: false
      };

    case INPUT_ERROR:
      return {
        ...state,
        [field]: {
          ...state[field],
          error
        },
        loading: false
      };

    case RESET_FORM:
      return {
        ...state,
        reportUrl: {
          ...state.reportUrl,
          value: "",
          error: ""
        },
        name: {
          ...state.name,
          value: "",
          error: ""
        },
        password: {
          ...state.password,
          value: "",
          error: ""
        },
        error: "",
        loading: false
      };

    case INPUT_CHANGE:
      return {
        ...state,
        [inputName]: {
          ...state[inputName],
          value: inputValue,
          error: ""
        }
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/add-report/add-report-reducer.js